export const Punctual: React.FC<{ className?: string; isActive: boolean }> = ({ className, isActive }) =>
  isActive ? (
    <svg viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <circle cx="36" cy="36" r="34" fill="#EDEDFD" stroke="#4B4DED" strokeWidth="4" />
      <g clipPath="url(#clip0_16872_8307)">
        <path
          d="M36.2002 50.2002C43.9322 50.2002 50.2002 43.9322 50.2002 36.2002C50.2002 28.4682 43.9322 22.2002 36.2002 22.2002C28.4682 22.2002 22.2002 28.4682 22.2002 36.2002C22.2002 43.9322 28.4682 50.2002 36.2002 50.2002Z"
          stroke="#262641"
          strokeWidth="4.008"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M36.2002 30.2002V36.2002L39.2002 39.2002" stroke="#4B4DED" strokeWidth="4.008" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M45.2202 46.9002L44.5202 54.5602C44.43 55.5575 43.9692 56.4847 43.2286 57.1587C42.4879 57.8326 41.5215 58.2043 40.5202 58.2002H31.8602C30.8588 58.2043 29.8924 57.8326 29.1518 57.1587C28.4112 56.4847 27.9503 55.5575 27.8602 54.5602L27.1602 46.9002M27.1802 25.5002L27.8802 17.8402C27.97 16.8464 28.428 15.922 29.1644 15.2485C29.9008 14.5751 30.8623 14.2012 31.8602 14.2002H40.5602C41.5615 14.1962 42.5279 14.5678 43.2686 15.2418C44.0092 15.9157 44.47 16.8429 44.5602 17.8402L45.2602 25.5002"
          stroke="#4B4DED"
          strokeWidth="4.008"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16872_8307">
          <rect width="48" height="48" fill="white" transform="translate(12.2002 12.2002)" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg className={className} viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="33" cy="33" r="31.5" fill="#F2F2F4" stroke="#C3C3CB" stroke-width="3" />
      <g clip-path="url(#clip0_14992_123120)">
        <path
          d="M33.2002 47.2002C40.9322 47.2002 47.2002 40.9322 47.2002 33.2002C47.2002 25.4682 40.9322 19.2002 33.2002 19.2002C25.4682 19.2002 19.2002 25.4682 19.2002 33.2002C19.2002 40.9322 25.4682 47.2002 33.2002 47.2002Z"
          stroke="#C3C3CB"
          stroke-width="4.008"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M33.2002 27.2002V33.2002L36.2002 36.2002" stroke="#C3C3CB" stroke-width="4.008" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M42.2202 43.9002L41.5202 51.5602C41.43 52.5575 40.9692 53.4847 40.2286 54.1587C39.4879 54.8326 38.5215 55.2043 37.5202 55.2002H28.8602C27.8588 55.2043 26.8924 54.8326 26.1518 54.1587C25.4112 53.4847 24.9503 52.5575 24.8602 51.5602L24.1602 43.9002M24.1802 22.5002L24.8802 14.8402C24.97 13.8464 25.428 12.922 26.1644 12.2485C26.9008 11.5751 27.8623 11.2012 28.8602 11.2002H37.5602C38.5615 11.1962 39.5279 11.5678 40.2686 12.2418C41.0092 12.9157 41.47 13.8429 41.5602 14.8402L42.2602 22.5002"
          stroke="#C3C3CB"
          stroke-width="4.008"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14992_123120">
          <rect width="48" height="48" fill="white" transform="translate(9.2002 9.2002)" />
        </clipPath>
      </defs>
    </svg>
  );
